import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { AutoMaintenances } from './types';
import { Table, dateFormatter, editIconFormatter, deleteIconFormatter, TableSortCaret } from '../../components/Table';
import styles from '../../components/Table/Table.module.scss';
import ColumnHeaderWithHelp from '../../components/Common/ColumnHeaderWithHelp';
import { deleteMaintenance, getMaintenanceList } from './autoSlice';

const DescriptionHelp = () => {
  return (
    <>
      <ul className="mb-0">
        <li>Enter the description of the maintenance here. </li>
        <br />
        <li>Example: Front Break Change - Ford, Oil Change - Civic. </li>
      </ul>
    </>
  );
};

const TargetPriceHelp = () => {
  return (
    <>
      <ul className="mb-0">
        <li>Add estimated cost of the maintenance here.</li>
        <br />
        <li>You can look up this amount from your previous bills or simply look up Arctic Rich guidelines. </li>
        <br />
        <li>Learn more in the Knowledge Section.</li>
      </ul>
    </>
  );
};

const TargetDateHelp = () => {
  return (
    <>
      <ul className="mb-0">
        <li>
          Enter the <b>Scheduled Maintenance Date</b> here according the automobile&apos;s manufacturer&apos;s guidance.
        </li>
        <br />
        <li>Take into account when the previous maintenance or servicing was done. </li>
      </ul>
    </>
  );
};

export interface MaintenanceTableProps {
  list: AutoMaintenances;
}

const maintenanceFormatter = (priority: string) => {
  return <span>{priority}</span>;
};

export const MaintenanceTable: React.FC<MaintenanceTableProps> = ({ list }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const getMaintenanceListAction = useCallback(() => dispatch(getMaintenanceList()), [dispatch]);

  const deleteEntityAction = async (id: number) => {
    await deleteMaintenance(id);
    getMaintenanceListAction();
  };

  const columns = [
    {
      dataField: 'description',
      text: 'Description',
      sort: true,
      helpText: <DescriptionHelp />,
      formatter: maintenanceFormatter,
      sortCaret: TableSortCaret,
      headerFormatter: ColumnHeaderWithHelp,
    },
    {
      dataField: 'target_price',
      text: 'Amount',
      sort: true,
      helpText: <TargetPriceHelp />,
      sortCaret: TableSortCaret,
      headerFormatter: ColumnHeaderWithHelp,
    },
    {
      dataField: 'target_date',
      text: 'Target Date',
      helpText: <TargetDateHelp />,
      formatter: dateFormatter('MMM dd, yyyy'),
      sort: true,
      sortCaret: TableSortCaret,
      headerFormatter: ColumnHeaderWithHelp,
    },
    {
      dataField: 'id',
      text: 'Edit',
      sort: false,
      helpText: <DescriptionHelp />,
      formatter: editIconFormatter,
      classes: styles.editIconColumn,
      formatExtraData: {
        baseUrl: '/asset/auto/edit/maintenance/',
        locationObj: location,
      },
    },
    {
      dataField: 'delete',
      text: 'Delete',
      sort: false,
      formatter: deleteIconFormatter(deleteEntityAction),
      classes: styles.deleteIconColumn,
    },
  ];
  return <Table keyField="id" data={list} columns={columns} bootstrap4 />;
};
